var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      staticStyle: { "flex-direction": "row", padding: "20px 20px 10px 20px" }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            disabled: _vm.readonly,
            inline: true,
            "label-width": "90px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { "margin-right": "40px" },
              attrs: { label: _vm.$t("Partners.agentLevel") }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "350px" },
                  attrs: { no: "grade" },
                  model: {
                    value: _vm.form.grade,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "grade", $$v)
                    },
                    expression: "form.grade"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("Partners.masterAgent"), value: 0 }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("Partners.secondaryAgent"),
                      value: 1
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Partners.networkManager") } },
            [
              _c("cargo-user-select", {
                staticStyle: { width: "350px" },
                attrs: {
                  no: "networkManager",
                  "method-params": { category: "role", shape: "sales" },
                  "callback-params": { key: "owner" },
                  "default-value": _vm.form.owner || ""
                },
                on: {
                  change: function(params) {
                    return (_vm.form.owner = params.value)
                  }
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Partners.billingAddress") } },
            [
              _c("el-input", {
                staticStyle: { width: "350px" },
                attrs: { no: "billAddress", type: "textarea", rows: 10 },
                model: {
                  value: _vm.form.billAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "billAddress", $$v)
                  },
                  expression: "form.billAddress"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
            [
              _c("el-input", {
                staticStyle: { width: "350px" },
                attrs: { no: "remark", type: "textarea", rows: 10 },
                model: {
                  value: _vm.form.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.networkList.length > 0
        ? _c(
            "div",
            { staticStyle: { width: "350px", height: "238px" } },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("Partners.network")))]),
              _c("cargo-ag-grid", {
                staticStyle: { height: "100%" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.networkList
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }